export { default } from './DealsList';
